import React, { Component } from 'react'
import { TABLA_MENU_DE_MUESTRAS } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class MenuDeMuestrasTablaView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_MENU_DE_MUESTRAS} />
    )
  }
}
